<template>
    <div>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="closeErrorAndRedirect"
            />
        </div>

        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5 pl-7">{{ this.parentObject.pageTitle }}<span class="page_title_value pl-1">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-row>
                    <div class="pt-2 pl-7 pb-5">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 70px;"
                            @click="backHandler" 
                            > 
                            {{$t('button.back')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>
                
                <v-container
                    id="scroll-target"
                    class="overflow-y-auto px-5"
                >

                <div>
                    <v-row>
                        <v-col cols="3" sm="3" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.exercisecode')"
                                ref="kpiexercode"
                                readonly
                                v-model="formData.kpiexercode"
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>


                        <v-col cols="8" sm="8" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.exercisedesc')"
                                ref="kpiexerdesc"
                                readonly
                                v-model="formData.kpiexerdesc"
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                            <v-text-field
                                outlined
                                :label="$t('columns.periodstartdate')"
                                ref="startdate"
                                type="date"
                                readonly
                                v-model="formData.startdate"
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>


                        <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                            <v-text-field
                                outlined
                                :label="$t('columns.periodenddate')"
                                ref="enddate"
                                type="date"
                                readonly
                                v-model="formData.enddate"
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                            <v-text-field
                                outlined
                                :label="$t('columns.status')"
                                ref="kpiexerstatus"
                                readonly
                                v-model="formData.kpiexerstatus"
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n5 mt-n6">
                            <v-text-field
                                outlined
                                :label="$t('pmkpiinclusion.kpiinclusionset')"
                                type="text"
                                :items="KPILibraryInclusionSetList"
                                v-model="formData.pmkpiinclusiondescription"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.pmkpiinclusioncode"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </div>

                <v-card>
                    <div class="ma-4">
                        <v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader>
                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 ">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.servicerecordasatdate')"
                                    type="date"
                                    ref="servicerecasatdate"
                                    :rules="[rules.required]"
                                    v-model="formDataParameter.servicerecasatdate"
                                    @input="updateValue"
                                    @change="updateValue"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.hirecutoffdate')"
                                    type="date"
                                    ref="hiredate"
                                    :rules="[rules.required]"
                                    v-model="formDataParameter.hiredate"
                                    @input="updateValue"
                                    @change="updateValue"
                                    dense
                                ></v-text-field>
                            </v-col>


                            <v-col cols="5" sm="5" class="pb-n5 mt-n6">
                                <h4 class="pt-3 grey--text font-weight-light">
                                    {{ $t('performancemanagement.staffwithhiredate')}}
                                </h4>
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.cessationcutoffdate')"
                                    type="date"
                                    ref="cessationdate"
                                    :rules="[rules.required]"
                                    v-model="formDataParameter.cessationdate"
                                    @input="updateValue"
                                    @change="updateValue"
                                    dense
                                ></v-text-field>
                            </v-col>


                            <v-col cols="5" sm="5" class="pb-n5 mt-n6">
                                <h4 class="pt-3 grey--text font-weight-light">
                                     {{ $t('performancemanagement.staffwithcessationdate')}}
                                </h4>
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="1" sm="1" class="pb-n5 mt-n6">
                                <v-checkbox
                                    class="ml-n6"
                                    ref="isOverwrite"
                                    v-model="formDataParameter.isOverwrite"
                                    @input="updateValue"
                                    @change="updateValue"
                                    dense
                                ></v-checkbox>
                            </v-col>


                            <v-col cols="7" sm="7" class="pb-n5 mt-n6 ml-n10">
                                <h4 class="pt-3 grey--text font-weight-light">
                                     {{ $t('performancemanagement.overrideexisting')}}
                                </h4>
                            </v-col>

                        </v-row>
                    </div>
                </v-card>

                 <app-parameter 
                    class="mt-5 mb-3"
                    v-on:input="parameters = $event"
                    v-bind:parentObject="{
                        parameters: this.parameters,
                        filter: this.showFilter,
                    }"
                />

                </v-container>

                <v-row>
                    <div class="pt-5 pl-7">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="primary" 
                            style="width: 100px; margin-bottom: 20px;"
                            @click="generateHandler" 
                            > 
                             {{ $t('button.generate')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>


            </v-form>
            <v-overlay :value="loading" absolute>
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-dialog v-model="showLogDialog" max-width="700" persistent>
                <v-card>
                    <v-card-title class="headline">{{ $t('performancemanagement.generationcomplete') }}</v-card-title>
                    <v-card-text>
                        <v-alert type="success" dense class="mb-2">
                            {{ generationLog.newlyInserted }} {{ $t('performancemanagement.staffnewlygenerated') }}
                        </v-alert>
                        <v-alert v-if="generationLog.alreadyExisted > 0" type="info" dense class="mb-2">
                            {{ generationLog.alreadyExisted }} {{ $t('performancemanagement.staffalreadyexisted') }}
                        </v-alert>
                        <v-alert v-if="generationLog.skipped.length > 0" type="warning" dense class="mb-2">
                            {{ generationLog.skipped.length }} {{ $t('performancemanagement.staffexcluded') }}
                        </v-alert>
                        <v-data-table
                            v-if="generationLog.skipped.length > 0"
                            :headers="skippedHeaders"
                            :items="generationLog.skipped"
                            dense
                            class="elevation-1"
                            :items-per-page="5"
                        ></v-data-table>
                        <p v-else class="mt-2 grey--text">{{ $t('performancemanagement.allstaffincluded') }}</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="generationLog.skipped.length > 0"
                            color="secondary"
                            text
                            @click="downloadGenerationLog"
                        >
                            {{ $t('button.downloadlog') }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="generationLog.newlyInserted === 0 && generationLog.alreadyExisted === 0"
                            color="warning"
                            @click="backFromLogDialog"
                        >
                            {{ $t('button.back') }}
                        </v-btn>
                        <v-btn
                            v-else
                            color="primary"
                            @click="goToKPISettingGenerateStaff"
                        >
                            {{ $t('performancemanagement.viewgeneratedstaff') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="closeErrorAndRedirect"
            />
            </div>
        </v-container>
    </div>
</template>

<script>
import moment from "moment";
import FilterParameter from '../../../components/performancemanagement/targetsetting/FilterParameter';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-parameter': FilterParameter,
        'app-error': ErrorDialog
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            //KPI Exercise 
            formData: {
                kpiexerid: this.parentObject.data.kpiexerid,
                kpiexercode: this.parentObject.data.kpiexercode,
                kpiexerdesc: this.parentObject.data.kpiexerdesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                kpiexerstatusid: this.parentObject.data.kpiexerstatusid,
                kpiexerstatus: this.parentObject.data.kpiexerstatus,
                wfroleid: this.parentObject.data.wfroleid,
                wfrolecode: this.parentObject.data.wfrolecode,
                staffFirst: this.parentObject.data.staffFirst,
                pmkpiinclusionid: this.parentObject.data.pmkpiinclusionid,
                pmkpiinclusioncode: this.parentObject.data.pmkpiinclusioncode,
                pmkpiinclusiondescription: null,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid,
            },
            
            //Date Parameters
            formDataParameter: {
                servicerecasatdate: this.parentObject.dataParameter.servicerecasatdate,
                hiredate: this.parentObject.dataParameter.hiredate,
                cessationdate: this.parentObject.dataParameter.cessationdate,
                isOverwrite: this.parentObject.dataParameter.isOverwrite,
            },

            //Filter Parameters
            parameters: {
                compnyid: this.parentObject.parameters.compnyid,
                compnyname: this.parentObject.parameters.compnyname,
                brchid: this.parentObject.parameters.brchid,
                brchname: this.parentObject.parameters.brchname,
                deptid: this.parentObject.parameters.deptid,
                deptname: this.parentObject.parameters.deptname,
                divnid: this.parentObject.parameters.divnid,
                divnname: this.parentObject.parameters.divnname,
                sectioid: this.parentObject.parameters.sectioid,
                sectioname: this.parentObject.parameters.sectioname,
                unitid: this.parentObject.parameters.unitid,
                unitname: this.parentObject.parameters.unitname,
                grdid: this.parentObject.parameters.grdid,
                grddesc: this.parentObject.parameters.grddesc,
                emptypeid: this.parentObject.parameters.emptypeid,
                emptypecatdesc: this.parentObject.parameters.emptypecatdesc,
                staffid: this.parentObject.parameters.staffid,
                staffcode: this.parentObject.parameters.staffcode,
                jobid: this.parentObject.parameters.jobid,
                jobtitle: this.parentObject.parameters.jobtitle,
            },

            showFilter: {
                compnyid: true,
                brchid: true,
                deptid: true,
                divnid: true,
                sectioid: true,
                unitid: true,
                grdid: true,
                emptypeid: true,
                staffid: true,
                jobid: true,
            },

            staffList: this.parentObject.staffList,
            statusList: this.parentObject.statusList,

            KPILibraryInclusionSetList: [],
            KPILibraryInclusionSetFull: [],

            loading: false,

            companyname: [],
            companyList: [],
            errMsg: "",
            isErr: false,

            showLogDialog: false,
            generationLog: {
                newlyInserted: 0,
                alreadyExisted: 0,
                skipped: [],
            },
            skippedHeaders: [
                { text: this.$t('columns.staffcode'), value: 'staffcode', sortable: false },
                { text: this.$t('columns.staffname'), value: 'staffname', sortable: false },
                { text: this.$t('columns.reason'), value: 'reason', sortable: false },
            ],
        }
    },

    methods: {

        closeErrorAndRedirect() {
            this.isErr = false;
            this.$router.push({ name: 'kpisettinglist' });
        },

        async generateHandler(){
            this.loading = true;
            await this.generateStaff();
        },

        goToKPISettingGenerateStaff() {
            this.showLogDialog = false;
            this.loading = false;
            this.$router.push({name: 'kpisettinggeneratestaff', params: { formData: this.formData, formDataParameter: this.formDataParameter, parameters: this.parameters}});
        },

        backFromLogDialog() {
            this.showLogDialog = false;
            this.loading = false;
        },

        downloadGenerationLog() {
            const headers = ['Staff Code', 'Staff Name', 'Reason'];
            const rows = this.generationLog.skipped.map(s => [
                s.staffcode || '',
                s.staffname || '',
                s.reason || '',
            ]);
            const csvContent = [headers, ...rows]
                .map(row => row.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
                .join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `kpi-generation-log-${this.formData.kpiexercode}.csv`;
            link.click();
            URL.revokeObjectURL(url);
        },

        backHandler(){
            if (this.parentObject.isEdit){
                this.$router.push({ name: "kpisettingedit", params: { id: this.formData.kpiexerid } });
            }else {
                this.$router.push({name: 'kpisettingnew', params: { formData: this.parentObject.data, formDataParameter: this.formDataParameter, parameters: this.parameters }});
            }
        },

        updateValue() {
            this.$emit("input", {
                servicerecasatdate: this.formDataParameter.servicerecasatdate,
                hiredate: this.formDataParameter.hiredate,
                cessationdate: this.formDataParameter.cessationdate,
                isOverwrite: this.formDataParameter.isOverwrite,
                
            });
        },

        loadKPILIbraryInclusionSetHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpiinclusion/all' })
            .then((res) => {

                vm.KPILibraryInclusionSetFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.KPILibraryInclusionSetList.push({
                        text: res.data.rec[i].description,
                        value: res.data.rec[i].id,
                    });
                }

                if (vm.formData.pmkpiinclusionid) {
                    let item = this.KPILibraryInclusionSetFull.find((item) => item.id === vm.formData.pmkpiinclusionid);
                    vm.formData.pmkpiinclusiondescription = item.description;
                    this.formData.pmkpiinclusioncode = item.code;
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        async generateStaff() {
            const vm = this;
            //formData - KPI Exercise 
            //formDataParameter - Date Parameters
            //parameters - Filter Parameters
            const data = {
                formData: vm.formData,
                formDataParameter: vm.formDataParameter,
                parameters: vm.parameters,
            };

            try {
                // Dispatch the post request with the payloads object
                const res = await this.$store.dispatch('post', { url: "/kpiexercise/generate/", payload: data });

                if (res.status === 201 || res.status === 200) {
                    console.log("RES", res);
                    console.log("FORMDATA", vm.formData);
                    const insertedRecords = res.data.insertedRecords || [];
                    vm.generationLog.skipped = res.data.skippedStaff || [];
                    vm.generationLog.newlyInserted = res.data.newlyInserted || 0;
                    vm.generationLog.alreadyExisted = res.data.alreadyExisted || 0;
                    if (insertedRecords.length === 0) {
                        vm.loading = false;
                        vm.showLogDialog = true;
                        return;
                    }
                    await vm.generateIndividualKPI(insertedRecords);
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error || res.data.message || 'An unexpected error occurred.';
                }
            } catch (err) {
                console.error('Error in generateStaff:', err);
                vm.isErr = true;
                vm.errMsg = err.message || String(err);
            }
        },

        //No more in use because separated initiate Workflow
        //Keep for now in case if ever need for future use
        // async generateWfTran(staffRecords, staffFirst){
        //     //staffRecords - Staff Records that has just been generated
        //     //staffFirst - indicator if staff or reviewer review first in the transaction
        //     const vm = this;

        //     const data = staffRecords.map(record => ({
        //         ...record,
        //         staffFirst
        //     }));

        //     console.log("DATA", data);
        //     console.log("EXERCISESTATUS" + vm.formData.kpiexerstatusid);
        //     //send exercise status, only email if status is open 
        //     try {
        //         // Dispatch the post request with the payloads object
        //         const res = await this.$store.dispatch('post', { url: "/rbwftran/create/" + vm.formData.kpiexerstatusid, payload: data });

        //         if (res.status === 201) {
        //             console.log("RESWFTRAN", res);
        //         } else {
        //             vm.isErr = true;
        //             // Optionally handle the non-201 status here
        //         }
        //     } catch (err) {
        //         console.error('Error in generateWfTran:', err);
        //         vm.isErr = true;
        //         vm.errMsg = err;
        //     }
        // },

        async generateIndividualKPI(staffRecords){
            console.log("generateIndividualKPI");
            // staffRecords - Staff Records that has just been generated
            const vm = this;

            try {
                const res = await this.$store.dispatch('post', { url: "/kpiexercise/generate/indkpi/" + vm.formData.pmkpiinclusionid + "/" + vm.formDataParameter.servicerecasatdate, payload: staffRecords });

                if (res.status === 201) {
                    console.log("RESINDKPI", res);
                    if(res.data.idPairs && res.data.idPairs.length > 0){
                        await vm.generateIndividualKPIProgressReviews(res.data.idPairs);
                    } else{
                        vm.loading = false;
                        vm.showLogDialog = true;
                    }
                } else {
                    vm.isErr = true;
                }
            } catch (err) {
                console.error('Error in generateIndividualKPI:', err);
                vm.isErr = true;
                vm.errMsg = err;
            }
        },

        async generateIndividualKPIProgressReviews(idPairs){
            console.log("generateIndividualKPIProgressReviews");
            // idPairs - Individual KPI that's just been created and their subperiod counts
            // startdate and enddate - to use to estimate/get the dates in between the subperiod counts 

            // Based on the subperiodcount in each element, I want to get review date(s)
            // Example: subperiodcount = 4, startdate = 2023-01-01, enddate = 2023-12-31
            // I want to generate 4 review dates in between the startdate and enddate
            // Get the appropriate dates based on the subperiodcount
            // Then create a new array with the individualKPIIDs and their respective review dates
            const vm = this;

            const results = [];

            const start = moment(vm.formData.startdate);
            const end = moment(vm.formData.enddate);

            idPairs.forEach(({ insertedId, subperiodcount }) => {
                if (!subperiodcount || subperiodcount <= 0) return;

                const intervalDays = end.diff(start, 'day') / subperiodcount;

                for (let i = 1; i <= subperiodcount; i++) {
                    const reviewDate = start.clone().add(intervalDays * i, 'days').format('YYYY-MM-DD');
                    results.push({
                    individualkpiid: insertedId,
                    reviewdate: reviewDate
                    });
                }
            });

            try {
                const res = await this.$store.dispatch('post', { url: "/kpiexercise/generate/indkpiprg/" + vm.formData.userid , payload: results });

                if (res.status === 201) {
                    console.log("RESINDKPIPRG", res);
                    vm.loading = false;
                    vm.showLogDialog = true;
                } else {
                    vm.isErr = true;
                }
            } catch (err) {
                console.error('Error in generateIndividualKPIProgressReviews:', err);
                vm.isErr = true;
                vm.errMsg = err;
            }
        }
    },

    created(){
        this.loadKPILIbraryInclusionSetHandler();
    }
}
</script>
